import { atom } from 'jotai';

const userTokenAtom = atom <string | undefined>(undefined);

export default userTokenAtom;
